// extracted by mini-css-extract-plugin
module.exports =  {"inline-link":"index__inline-link___JNoum","inlineLink":"index__inline-link___JNoum","external-icon":"index__external-icon___DNyVr","externalIcon":"index__external-icon___DNyVr"};